export default "<div>\n    <div data-dojo-attach-point=\"mainContentContainer\"></div>\n</div>\n"